<ng-container *transloco="let t">
    <div
        #reference
        class="tms-button-tooltip"
    >
        <bazis-button
            [color]="color"
            [disabled]="disabled"
            [size]="size"
            [fill]="fill"
            (click)="buttonAction()"
        >
            <bazis-icon
                slot="icon-only"
                [icon]="icon"
            ></bazis-icon>
        </bazis-button>
        <bazis-tooltip
            [reference]="reference"
            placement="top"
            class="bh-popper-z-index"
        >
            {{ t(tooltipKey, tooltipParams) }}
        </bazis-tooltip>
    </div>
</ng-container>
